import { render, staticRenderFns } from "./BoletimMedicaoItens.vue?vue&type=template&id=5289372c&scoped=true&"
import script from "./BoletimMedicaoItens.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoItens.vue?vue&type=script&lang=js&"
import style0 from "./BoletimMedicaoItens.vue?vue&type=style&index=0&id=5289372c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5289372c",
  null
  
)

export default component.exports